<template>
  <div class="sf-empty-state">
    <img
      class="sf-empty-state-image"
      :alt="I18n.t('company_links.empty_state.title')"
      :src="$imagesRequire('empty_states/adjustments.svg')"
    />
    <div class="sf-empty-state-title">
      {{ I18n.t('company_links.empty_state.title') }}
    </div>
    <div class="sf-c-text sf-below-1">
      <span
        v-dompurify-html="I18n.t('company_links.empty_state.message_html')"
      />
    </div>
    <div class="tw-flex tw-justify-center">
      <SfButtonDs
        variant="primary"
        icon-before="plus"
        @click="openManageCompanyLinksModal"
      >
        {{ I18n.t('company_links.empty_state.create') }}
      </SfButtonDs>
    </div>
  </div>
</template>

<script setup lang="ts">
import useI18n from '@app/shared/vue/composables/use-I18n'
import { SfButtonDs } from '@silverfin/ui-components'

const I18n = useI18n()

const openManageCompanyLinksModal = () => {
  window.modalCitizen.openModalPortal('manage-company-links-modal')
}
</script>
